<template>
    <div>
        <div class="mul-select-btn-group">
            <template v-for="item in options">
                <van-button
                    @click="selectOptionClick(item.id)"
                    :class="activeOptions.includes(item.id) ? 'active' : ''"
                    >{{ item.name }}</van-button
                >
            </template>
        </div>
        <div class="dropdown-btn-group">
            <van-button @click="activeOptions=[]">重置</van-button>
            <van-button type="primary" color="#02d644" @click="selectedDone" style="font-weight:bold;">完成</van-button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["options"],
    data() {
        return {
            activeOptions: [],
        };
    },
    methods: {
        selectOptionClick(item) {
            console.log("option clicked", item);
            if (this.activeOptions.includes(item)) {
                // 删除
                this.activeOptions = this.activeOptions.filter(
                    (i) => i != item
                );
            } else {
                this.activeOptions.push(item);
            }
        },
        selectedDone(){
            console.log("选完了 in MulSelectBtnGroup", this.activeOptions);
            this.$emit("change", this.activeOptions)
        }
    },
    created() {
        console.log("created in MulSelectBtnGroup", this.options);
    },
};
</script>
<style scoped lang="scss">
.mul-select-btn-group {
    padding: 24px 32px 0 17px;
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-between;
    button {
        width: 218px;
        height: 64px;
        margin-top: 16px;
        margin-left:15px;
        background: #f5f5f5;
        border-radius: 8px;
        font-size: 24px;
        color: #333333;
        letter-spacing: 0;
    }
    button.active {
        background: #f9f5ff;
        border: 2px solid rgba(100, 23, 255, 0.5);
        color: #6417ff;
    }
    /deep/ .van-button--default{
        border:none;
    }
}

.dropdown-btn-group {
        display: flex;
        justify-content: space-between;
        position: fixed;
        left: 0;
        right: 0;
        top: calc(50% + 40px);

        margin: 0;
        padding:0 40px;
        height: 140px;
        line-height: 140px;
        border-top: solid #E0E0E0 1px;
        background: white;

        button {
            margin-top: 24px;
            width: 326px;
            height: 84px;
            border-radius: 42px;

        }
}
</style>



// WEBPACK FOOTER //
// MulSelectBtnGroup.vue?613fe468